import {
    Box,
    Card,
    CardContent,
    Tab,
    Tabs,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import AdminDashboardLayout from "../../../layouts/admin_dashboard_layout/admin_dashboard_layout";
import UploadNewsTab from "./upload_news_tab";
import EditNewsTab from "./edit_news_tab";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`news-tabpanel-${index}`}
            aria-labelledby={`news-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

function News() {
    const [currentTab, setCurrentTab] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setCurrentTab(newValue);
    };

    return (
        <AdminDashboardLayout>
            <Box flex={1} mt={2} mx={2}>
                <Card sx={{ borderRadius: 1, m: 3 }} elevation={1}>
                    <CardContent>
                        <Typography variant="h5" fontWeight="600" mb={2}>
                            News Management
                        </Typography>

                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                                value={currentTab}
                                onChange={handleTabChange}
                                aria-label="news management tabs"
                            >
                                <Tab label="Upload News" id="news-tab-0" />
                                <Tab label="Edit News" id="news-tab-1" />
                            </Tabs>
                        </Box>

                        <TabPanel value={currentTab} index={0}>
                            <UploadNewsTab />
                        </TabPanel>

                        <TabPanel value={currentTab} index={1}>
                            <EditNewsTab />
                        </TabPanel>
                    </CardContent>
                </Card>
            </Box>
        </AdminDashboardLayout>
    );
}

export default News;
